@if(titre){
    <tui-island [class]="['statut-'+statut]">
        <div class="tui-space_bottom-2">
            {{ titre }}
        </div>
        <h3 class="tui-island__title">
            <ng-content />
        </h3>
        <p class="tui-island__paragraph">
            {{ sousTitre }}
        </p>
    </tui-island>
}@else{
    <tui-island [class]="['statut-'+statut]">
        <div class="tui-space_bottom-2 placeholder">
            XXXXXX
        </div>
        <h3 class="tui-island__title placeholder">
            0.00XX
        </h3>
        <p class="tui-island__paragraph placeholder">
            Au 00/00/0000
        </p>
    </tui-island>
}